import styled from "styled-components"
import FadeIn from "react-fade-in"

const ContainerLight = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_medium};
  & > div {
    background-color: ${(props) => props.theme.a_color_gradients.a_medium};
  }
`
const BorderTaxo = styled.button`
  border: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
  color: ${(props) =>
    props.activeBool ? props.activeText : props.theme.b_color_gradients.b_dark};
  background-color: ${(props) =>
    props.activeBool ? props.theme.b_color_gradients.b_dark : props.activeText};
  &:hover {
    background-color: ${(props) =>
      props.activeBool ? null : props.theme.b_color_gradients.b_dark};
    color: ${(props) => (props.activeBool ? null : props.activeText)};
  }
`
const EventsItem = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
  margin-bottom: 0;
  &:hover div:first-of-type::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`
const StyledFade = styled(FadeIn)`
  & > div:nth-of-type(1),
  & > div:nth-of-type(3) {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

const EventsPeriodFilter = styled.p`
  color: ${(props) =>
    props.active === true
      ? props.theme.b_color_gradients.b_dark
      : props.theme.c_color_gradients.c_dark};
  text-decoration: ${(props) =>
    props.active === true ? "dashed underline" : "none"};
`

const EventsPeriodFilterContainer = styled.div`
  border-right: 2px solid ${(props) => props.theme.a_color_gradients.a_light};
  @media (max-width: 900px) {
    border-bottom: 2px solid ${(props) => props.theme.a_color_gradients.a_light};
  }
`

export {
  ContainerLight,
  EventsItem,
  BorderTaxo,
  StyledFade,
  EventsPeriodFilterContainer,
  EventsPeriodFilter,
}
